import { LitElement, html, css } from "lit";
import "./header-mobile.css";

const TRIGGER = 200;
const DESKTOP = "(max-width:991px)";
const isDesktop = !window.matchMedia(DESKTOP).matches;
export class HeaderMobile extends LitElement {
  static styles = css`
    *,
    ::before,
    ::after {
      box-sizing: border-box;
      border-style: solid;
      border-width: 0;
    }

    a {
      line-height: 0;
    }

    :host {
      position: fixed;
      display: flex;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      transition: all 250ms ease;
    }

    header {
      transition: padding 500ms ease 200ms, background 350ms ease 200ms;
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .--notTransparent {
      background: rgba(255, 255, 255, 1);
    }

    .wrapper {
      display: flex;
      width: calc(100% - 76px);
      flex-direction: column;
      justify-content: space-between;
    }

    .logo,
    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .logo img {
      height: 27px;
    }

    img {
      height: 60px;
    }

    .button span {
      text-align: right;
      font-family: var(--font-02);
      font-size: var(--font-size-default);
      color: var(--header-mobile-close-color-button);
    }

    .icon {
      width: 32px;
      height: 32px;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .bottom {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--header-mobile-background-open);
      color: white;
      transform: translate3d(0, 0, 0);
      transition: all 600ms cubic-bezier(0.65, 0.05, 0.36, 1) 0s;
      overflow: auto;
      background: #001b40 url("/wp-content/themes/fc-action-europe/public/reference-bg.png")
        no-repeat center center;
      background-size: cover;
      min-height: 240px;
    }

    .top {
      display: flex;
      justify-content: space-between;
      height: 60px;
      z-index: 1;
      transition: all 0.2s ease;
    }

    .--close .bottom {
      transform: translate3d(0, -100%, 0);
    }

    #icon_burger,
    #icon_burger:after,
    #icon_burger:before {
      height: 2px;
      display: block;
      background-color: white;
      width: 20px;
      transition: all 150ms ease;
    }

    #icon_burger {
      opacity: 0.8;
      position: relative;
      display: flex;
      flex-direction: row-reverse;
    }

    .icon:hover #icon_burger {
      opacity: 1;
    }

    #icon_burger:after,
    #icon_burger:before {
      position: absolute;
      content: " ";
    }
    #icon_burger:after {
      top: -6px;
    }
    #icon_burger:before {
      top: 6px;
      width: 80%;
      justify-align: flex-end;
    }

    .--open #icon_burger {
      background-color: transparent;
    }

    .--open #icon_burger:after,
    .--open #icon_burger:before {
      background-color: white;
    }
    .--open #icon_burger:after {
      transform: translateY(6px) rotate(45deg);
    }
    .--open #icon_burger:before {
      width: 100%;
      transform: translateY(-6px) rotate(-45deg);
    }
    .--dark #icon_burger,
    .--dark #icon_burger:after,
    .--dark #icon_burger:before {
      background-color: var(--header-mobile-close-color-button, black);
    }

    @media screen and (min-width: 992px) {
        .icon {
          position: absolute;
          right: 30px
        }
        .--open .icon {
            right:-23px
        }
      .--open .button {
        transform: translateX(-15px);
      }
      .--big {
        padding: 8px 0;
      }
    }
  `;
  static properties = {
    isLight: { type: Boolean },
    isPreviousState: { type: Boolean },
    isBig: { typeof: Boolean },
    isTransparent: { typeof: Boolean },
    isBackgroundFill: { typeof: Boolean },
    isOpen: { type: Boolean },
    logosrc: { type: String },
    logolightsrc: { type: String },
    logolink: { type: String },
    startTheme: { type: String },
    logoToDisplay: { type: String },
  };

  constructor() {
    super();
    this.isOpen = false;
    this.isLight = true;
    this.isTransparent = true;

    this.animationMenu = [];
    this.animateKeyframes = [
      {
        opacity: 0,
        transform: "translateY(30px)",
      },
      {
        opacity: 1,
        transform: "translateY(0px)",
      },
    ];
  }

  firstUpdated() {
   
    // this.querySelectorAll("a").forEach(
    //   (lien) =>
    //     (lien.onclick = (e) => {
    //       e.preventDefault();
    //       this.isOpen = false;
    //       document.querySelector('#page').style.opacity = 0
    //       setTimeout(() => {
    //         window.location.href = e.target.href;
    //       }, 500);
    //     })
    // );

    if (isDesktop) {
      this.isLight = true;
      this.isBig = true;
    }
    this.dispatchEvent(new CustomEvent("load"));
  }

  willUpdate(params) {
    // ISOPEN TRUE || FALSE
    if (params.has("isOpen")) {
      if (this.isOpen === true) {
        this.isPreviousState = this.isLight;
        this.setIsLight(true);
        this.dispatchEvent(new CustomEvent("open"));
        // animation
        this.querySelectorAll("nav li, .title-xs, social-item").forEach(
          (el, i) => {
            this.animeOnEnter(el, 75 * i);
          }
        );
        // scroll
        document.body.style.overflow = "hidden";
      } else {
        this.dispatchEvent(new CustomEvent("close"));
        this.setIsLight(this.isPreviousState);
        // animation
        this.animationMenu.forEach((el) => {
          el.effect.updateTiming({ direction: "reverse" });
        });
        // scroll
        document.body.style.overflow = "auto";
      }
    }

    if (params.has("isLight")) {
      this.isLight
        ? (this.logoToDisplay = this.logolightsrc)
        : (this.logoToDisplay = this.logosrc);
    }
  }

  setIsLight(val) {
    this.isLight = val;
  }

  setisBig(val) {
    this.isBig = val;
  }
  setisTransparent(val) {
    this.isTransparent = val;
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  toggleLogoHover() {
    this.logoToDisplay = this.isLight ? this.logolightsrc : this.logosrc;
  }

  /**
   *
   * @param {HTMlElement} element
   * @param {Number} delay
   */
  animeOnEnter(element, delay) {
    element.style.display = "block";
    element.style.opacity = this.animateKeyframes[0].opacity;
    element.style.transform = this.animateKeyframes[0].transform;
    let newDelay = 300 + delay;
    let anim = element.animate(this.animateKeyframes, {
      duration: 500,
      delay: newDelay,
      fill: "forwards",
      easing: "ease",
    });
    this.animationMenu.push(anim);
  }

  renderButtonMenu() {
    return html` <span id="icon_burger"></span> `;
  }
  render() {
    return html`
      <header
        class="${!this.isOpen ? "--close" : "--open"} ${this.isLight
          ? "--light"
          : "--dark"} ${this.isBig && " --big"} ${this.isTransparent ? "--transparent" : " --notTransparent"}">
        <div class="wrapper">
          <div class="top">
            <div class="logo">
              <a href="${this.logolink}" target="_parent">
                <img
                  src="${this.logoToDisplay}"
                  alt="logo"
                  height="100%"
                  width="100%"
                />
              </a>
            </div>
            <div class="button" @click=${this.toggleMenu}>
              <!-- <span> ${!this.isOpen ? "menu" : "fermer"}</span> -->
              <div class="icon">${this.renderButtonMenu()}</div>
            </div>
          </div>
          <div class="bottom ">
            <div class="bg-overlay"></div>
            <slot class="slot" name="content"> </slot>
          </div>
        </div>
      </header>
    `;
  }
}

customElements.define("header-mobile", HeaderMobile);

// Controle du comportements spécifiiques


document.querySelector("header-mobile").onload = function () {
  // si dekstop && section.hero
  const hero = document.querySelector(".section-hero");
  const header = this;
  // -mobile - etat : logo bleu - fond blanc
  if (isDesktop) {
    // -desktop - avant TRIGGER et Si section-hero : etat : logo blanc fond transparent
    // -desktop - après fermeture avant TRIGGER  et Si section-hero : etat : logo blanc fond transparent
    // -desktop - après TRIGGER  : etat : logo bleu - fond blanc
    // -desktop - après fermeture après TRIGGER  etat : logo bleu - fond blanc

    // initialisation
    if (hero) {
      header.isLight = true;
    }else{
      header.isLight = false;
    }

    window.addEventListener("scroll", handleScroll);
    document.querySelector("header-mobile").addEventListener("close", () => {
      handleScroll();
    });
  }

  function handleScroll() {
    if (window.scrollY < TRIGGER) {
      header.isTransparent = true;
      if (hero) {
        header.isLight = true;
      }
    } else {
      header.isTransparent = false;
      if (hero) {
        header.isLight = false;
      }
    }
  }


};
